import './_footer-legal.scss';

export default () => {};
